import React from 'react';
import ReactSelect, { StylesConfig } from 'react-select';
import AsyncReactSelect from 'react-select/async';
import clsx from 'clsx';

import css from './MultiSelect.module.scss';

const customStyles: StylesConfig = {
    option: (provided) => ({
        ...provided,
        color: '#4B4F56',
        background: '#fff',
        fontSize: '13px',
        '&:hover': { cursor: 'pointer', background: '#F4F5F8' },
    }),
    groupHeading: (provided) => ({
        ...provided,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        background: 'var(--pale)',
        margin: 0,
        height: '30px',
        fontSize: '16px',
        textTransform: 'capitalize',
    }),
    menu: (provided) => ({
        ...provided,
        width: '100%',
        height: 'auto',
        background: 'var(--white)',
        borderRadius: 'var(--radius2)',
        overflow: 'hidden',
    }),
    menuList: (provided) => ({
        ...provided,
        height: 'auto',
        maxHeight: '280px',
        margin: 0,
        padding: 0,
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    clearIndicator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    container: (provided) => ({
        ...provided,
        width: '100%',
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: 'var(--radius1)',
        fontSize: '14px',
        width: '100%',
        height: 'auto',
        color: '#a0a2a7',
        background: 'var(--pale)',
        boxShadow: '0px 0px 0px 1px var(--gray4) inset',
        border: 'none',
        '&:hover': { outline: 'none', cursor: 'pointer' },
    }),
    group: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'var(--gray2)',
        marginLeft: 'var(--gap5)',
    }),
    input: (provided) => ({
        ...provided,
        paddingLeft: '3px',
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: 'var(--radius0)',
        background: 'var(--white)',
        padding: '4px 6px 4px 2px',
        margin: '2px',
        border: '1px solid var(--pale-blue2)',
        alignItems: 'center',
        gap: '8px',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        padding: '0',
        fontSize: '13px',
        color: 'var(--gray)',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: 'var(--dark-blue)',
        opacity: 0.5,
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        background: '#ffffff80',
        '&:hover': { background: '#ffffff60', color: 'var(--blue)' },
        '&:active': { background: '#ffffff40', color: 'var(--blue)' },
        '& > svg': { transform: 'scale(1.8)' },
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--gray3)',
        '&:hover': { color: 'var(--gray2)' },
    }),
};

interface Props {
    options?: any;
    value?: any;
    onChange?: (options: any) => void;
    isAsync?: boolean;
    loadOptions?: ((input: string) => Promise<any>) | ((input: string, callback: Function) => void);
    cacheOptions?: boolean;
    placeholder?: string;
    menuIsOpen?: boolean;
    onMenuOpen?: Function;
    isSearchable?: boolean;
    error?: boolean;
}

const MultiSelect: React.FC<Props> = (props) => {
    const Component = props.isAsync ? AsyncReactSelect : ReactSelect;

    return (
        <div className={clsx(css.select, props.error && css.error)}>
            {/*@ts-ignore wrong upstream types*/}
            <Component {...props} styles={customStyles} isMulti noOptionsMessage={() => null} />
        </div>
    );
};

export default React.memo(MultiSelect);
